import React, { useEffect, useState } from 'react';
import { fetchImageFolders, fetchImagesInFolder, uploadImageToFolder, deleteImage } from '../api';

const ImageList = () => {
  const [folders, setFolders] = useState([]);
  const [selectedFolder, setSelectedFolder] = useState('');
  const [images, setImages] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [message, setMessage] = useState(''); // ✅ For gentle notifications

  // Function to show a message and have it disappear
  const showMessage = (text) => {
    setMessage(text);
    setTimeout(() => setMessage(''), 3000); // Hide after 3 seconds
  };
  
  // ... (useEffect hooks remain the same) ...


useEffect(() => {
  const loadFolders = async () => {
    const f = await fetchImageFolders();
    setFolders(f);
    if (f.length > 0) setSelectedFolder(f[0]);
  };
  loadFolders();
}, []);

useEffect(() => {
  const loadImages = async () => {
    if (selectedFolder) {
      const imgs = await fetchImagesInFolder(`static/images/${selectedFolder}`);
      setImages(imgs);
    }
  };
  loadImages();
}, [selectedFolder]);


  const handleUpload = async (e) => {
    const file = e.target.files[0];
    if (!file || !selectedFolder) return;
    setUploading(true);
    try {
      await uploadImageToFolder(`static/images/${selectedFolder}`, file);
      const imgs = await fetchImagesInFolder(`static/images/${selectedFolder}`);
      setImages(imgs);
      showMessage('Image uploaded successfully!'); // ✅ Use gentle notification
    } catch (err) {
      showMessage('Error: ' + err.message); // ✅ Use gentle notification
    }
    setUploading(false);
  };

  const handleDelete = async (imgPath) => {
    if (!window.confirm(`Are you sure you want to delete ${imgPath}?`)) return;
    try {
      await deleteImage(imgPath);
      const imgs = await fetchImagesInFolder(`static/images/${selectedFolder}`);
      setImages(imgs);
      showMessage('Image deleted.'); // ✅ Use gentle notification
    } catch (err) {
      showMessage('Error: ' + err.message); // ✅ Use gentle notification
    }
  };

  return (
    <div className="card">
      <h2 className="card-title">🖼️ Image Library</h2>

      <div className="form-group">
        <label htmlFor="folder-select">Folder:</label>
        <select id="folder-select" value={selectedFolder} onChange={e => setSelectedFolder(e.target.value)}>
          {folders.map(f => <option key={f} value={f}>{f}</option>)}
        </select>
        
        {/* ✅ Styled file upload button */}
        <label htmlFor="file-upload" className="custom-file-upload">
            {uploading ? 'Uploading...' : 'Upload Image'}
        </label>
        <input id="file-upload" type="file" accept="image/*" onChange={handleUpload} disabled={uploading || !selectedFolder} />
      </div>

      {/* ✅ Notification Area */}
      {message && <div style={{ marginBottom: '1rem', color: message.startsWith('Error') ? 'red' : 'green' }}>{message}</div>}

      <div className="image-list-container">
        <ul className="image-list" style={{paddingLeft: 0}}>
          {images.map(img => (
            <li key={img.path}>
              <span className="image-name">{img.name}</span>
              <button onClick={() => handleDelete(img.path)} className="icon-button" title="Delete" style={{color: 'var(--danger-color)'}}>🗑️</button>
            </li>
          ))}
          {images.length === 0 && !selectedFolder && <li><p>Select a folder to view images.</p></li>}
          {images.length === 0 && selectedFolder && <li><p>This folder is empty.</p></li>}
        </ul>
      </div>
    </div>
  );
};

export default ImageList;